<script setup>
const props = defineProps({
  agents: { type: Array, default: () => [] },
  title: { type: String, default: 'Ranking de Agentes' },
});

const formatCurrency = value => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value || 0);
};
</script>

<template>
  <div class="rounded-2xl border border-n-weak bg-n-solid-1 p-3">
    <h3 class="text-sm font-extrabold text-n-slate-12 mb-2">
      {{ title }}
    </h3>
    <div v-if="agents.length === 0" class="text-sm text-n-slate-10 py-3 text-center">
      Nenhum agente encontrado no período
    </div>
    <div v-else class="overflow-x-auto">
      <table class="w-full text-[13.5px]">
        <thead>
          <tr class="border-b border-n-weak">
            <th class="text-left py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">#</th>
            <th class="text-left py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">Agente</th>
            <th class="text-center py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">Total</th>
            <th class="text-center py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">Ganhos</th>
            <th class="text-center py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">Perdidos</th>
            <th class="text-center py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">Conversão</th>
            <th class="text-right py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">Valor Ganho</th>
            <th class="text-center py-2 px-3 text-[11.5px] font-bold uppercase tracking-wide text-n-slate-10">Movimentações</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(agent, index) in agents"
            :key="agent.id"
            class="border-b border-n-weak hover:bg-n-alpha-2"
          >
            <td class="py-2.5 px-3 text-n-slate-10 font-medium tabular-nums">
              {{ index + 1 }}
            </td>
            <td class="py-2.5 px-3 text-n-slate-12 font-medium">
              {{ agent.name }}
            </td>
            <td class="py-2.5 px-3 text-center text-n-slate-11 tabular-nums">
              {{ agent.totalItems }}
            </td>
            <td class="py-2.5 px-3 text-center">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400">
                {{ agent.wonItems }}
              </span>
            </td>
            <td class="py-2.5 px-3 text-center">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400">
                {{ agent.lostItems }}
              </span>
            </td>
            <td class="py-2.5 px-3 text-center">
              <span
                class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                :class="agent.conversionRate >= 50
                  ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
                  : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400'"
              >
                {{ agent.conversionRate }}%
              </span>
            </td>
            <td class="py-2.5 px-3 text-right text-n-slate-12 font-medium">
              {{ formatCurrency(agent.wonValue) }}
            </td>
            <td class="py-2.5 px-3 text-center text-n-slate-11">
              {{ agent.stageChanges }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
